import { ValidationRules } from 'helpers/createFormConfig';
import { legalEntityValidationRules } from 'features/new-actor/form/validation-rules/legalEntityValidationRules';
import {
  borrowerBaseValidationRules,
  BorrowerLegalFormValues
} from '../borrowerInsuredForm';

export const borrowerLegalEntityValidationRules: ValidationRules<
  Exclude<keyof BorrowerLegalFormValues, 'id'>
> = {
  ...legalEntityValidationRules,
  ...borrowerBaseValidationRules
};
